/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const CatalogItemFacts = zod.object({
  catalogItemId: zod.uuid(),
  kind: zod.enum(["MATERIAL", "SERVICE"]),
  code: zod.string(),
  name: zod.string(),
  localizedDescription: zod.string(),
  unitCode: zod.string(),
  unitSymbol: zod.string(),
  priceProtected: zod.boolean(),
});

export type CatalogItemFacts = zod.input<typeof CatalogItemFacts>;
export type CatalogItemFactsOutput = zod.output<typeof CatalogItemFacts>;
